import React from "react";
import logo from "../assets/bayautomation.png";

export default function SplashScreen() {
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-white">
      <img
        src={logo}
        alt="Bay Automation"
        className="w-64 h-auto animate-pulse"
      />
    </div>
  );
}